(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentVersionDetailController', DocumentVersionDetailController);

    DocumentVersionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'DocumentVersion', 'DocumentVersionPage', 'Document'];

    function DocumentVersionDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, DocumentVersion, DocumentVersionPage, Document) {
        var vm = this;

        vm.documentVersion = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('jmrsignApp:documentVersionUpdate', function(event, result) {
            vm.documentVersion = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
